import { Component } from '@angular/core';

@Component({
  selector: 'app-loading-document',
  templateUrl: './loading-document.component.html',
  styleUrls: ['./loading-document.component.scss']
})
export class LoadingDocumentComponent { }
